import axios from 'axios';

const madriwaAPI = axios.create({
  baseURL: process.env.REACT_APP_MADRIWA_BASE_URL,
});

madriwaAPI.interceptors.request.use(
  async (config) => {
    const token = await sessionStorage.getItem('token');
    config.headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    };

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

madriwaAPI.interceptors.response.use(
  async (response) => {
    return response;
  },
  (err) => {
    return Promise.reject(err.response.data);
  }
);

export default madriwaAPI;
